// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Add: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M80,11 C80.5522847,11 81,11.4477153 81,12 L81,15 L84,15 C84.5522847,15 85,15.4477153 85,16 C85,16.5522847 84.5522847,17 84,17 L81,17 L81,20 C81,20.5522847 80.5522847,21 80,21 C79.4477153,21 79,20.5522847 79,20 L79,17 L76,17 C75.4477153,17 75,16.5522847 75,16 C75,15.4477153 75.4477153,15 76,15 L79,15 L79,12 C79,11.4477153 79.4477153,11 80,11 Z"
                transform="translate(-75 -11)"
            />
        </svg>
    );
};

export default React.memo(Add);
